import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/primitives'

type FeedbackFeatureSelectProps = {
  value: string
  options: Array<{ value: string; label: string }>
  onChange: (feature: string) => void
}

export function FeedbackFeatureSelect({ value, options, onChange }: FeedbackFeatureSelectProps) {
  return (
    <div className="space-y-1.5">
      <span className="text-sm font-medium">Feature area</span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger aria-label="Feature area">
          <SelectValue placeholder="Select a feature" />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
